import styled from "styled-components";
import { useEffect, useState } from "react";
import {
  List, ListItemText,
  styled as styled2,
} from "@mui/material";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { colors } from "../../../common/colors";
import LoadingModal from "../../../components/LoadingModal";
import { styles } from "../../../pages/styles";
import { useAppDispatch } from "../../../redux/store";
import apiServices from "../../services/apiServices";
import { setErrorObj } from "../../redux/errorReducer";
import DisplayModal from "../DisplayModal";
import SafeTextWithLinks from "../SafeTextWithLinks";

const Container = styled.div`
  margin-top: 7px;
  padding: 12px;
  padding-top: 0;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
  border: 2 sol;
`;

interface Props {
  open: boolean;
  post: any;
  highlightWords?: string[];
  closeModal(): void;
}
const VotesModal = ({ open, closeModal, post, highlightWords }: Props) => {
  const dispatch = useAppDispatch();
  const [voteOptions, setVoteOptions] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    if (!open || !post) return

    const getVoteOptions = async () => {
      setIsLoading(true)
      try {
        const res = await apiServices.getVoteOptions(post.id)
        const options = calculatePercentage(res.vote_options)
        setVoteOptions(options)
      } catch (error: any) {
        dispatch(setErrorObj(error))
      } finally {
        setIsLoading(false)
      }
    }
    getVoteOptions()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, post])

  const calculatePercentage = (options: any[]) => {
    const totalVotes = options.reduce(
      (total: any, option: { votes_count: any }) => total + option.votes_count,
      0
    );

    return options.map((option) => {
      const percentage =
        totalVotes > 0 ? (option.votes_count / totalVotes) * 100 : 0;
      return { ...option, percentage: percentage.toFixed(0) };
    });
  };

  const BorderLinearProgress = styled2(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor:
        theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: colors.farm_green500,
    },
  }));

  const handleClose = () => {
    closeModal()
    setIsLoading(true) //次回オープン時にモーダルがちらつかないようにする
  }

  return (
    <>
      <LoadingModal visible={isLoading && open} />
      <DisplayModal
        open={!isLoading && open}
        title={post.title}
        highlightWords={highlightWords}
        subtitle={post.vote_question}
        sx={style.container}
        onClose={handleClose}>
        <Container>
          <div style={{ maxHeight: "calc(100vh*0.9*0.7 - 90px)", overflow: "auto" }}>
            <List sx={style.list}>
              {voteOptions.map((item: any, index: number) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    backgroundColor: colors.farm_gray10,
                    padding: "8px 16px",
                    margin: "8px auto",
                    border: 2,
                    borderStyle: "solid",
                    borderRadius: "8px",
                    borderColor: colors.farm_green100,
                    fontFamily: "mplus-1c-bold",
                    color: colors.farm_black,
                    width: "100%",
                    textAlign: "left"
                  }}
                >
                  <ListItemText
                    primary={
                      <span
                        style={{
                          ...styles.communiTitleDescrip,
                          wordWrap: "break-word",
                        }}
                      >
                        <SafeTextWithLinks
                          text={item.option_text.toUpperCase()}
                          highlightWords={highlightWords}
                        />
                      </span>
                    }
                    secondary={
                      <div style={styles.detailVoteStatusTxt}>
                        <BorderLinearProgress
                          style={{ width: "90%" }}
                          variant="determinate"
                          value={Number(item.percentage)}
                        />
                        &nbsp;{item.percentage}&nbsp;%
                      </div>
                    }
                    secondaryTypographyProps={{ component: "div" }}
                  />
                </div>
              ))}
            </List>
          </div>
        </Container>
      </DisplayModal>
    </>
  );
};

export default VotesModal;

const style = {
  list: {
    "& .MuiListItemButton-root:hover": {
      bgcolor: colors.farm_gray10,
      "&, & .MuiListItemIcon-root": {
        color: "black",
      },
      "&$focusVisible": {
        backgroundColor: colors.farm_gray10,
      },
      "& .MuiListItemButton-root:touch": {
        bgcolor: colors.farm_gray10,
        "&, & .MuiListItemIcon-root": {
          color: "black",
        }
      }
    }
  },
  container: {
    width: "50%",
    maxWidth: "85%",
    textAlign: "center"
  }
}